<template>
  <div id="mapRoot">
    <div id="container"></div>
    <div id="navIcon"  @click="handleMapNav">
      <img
       
        src="../../assets/img/nav.png"
        alt="导航"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Map",
  components: {},

  data() {
    return {  };
  },
  created() {
    document.title = "导航";
  },
  mounted() {
    const { F_Longitude, F_Latitude, F_FullName, F_Address } = this.$route.query;
    const longitude = parseFloat(F_Longitude);
    const latitude = parseFloat(F_Latitude);
    const AMapRef = window.AMap;

    if (!AMapRef || Number.isNaN(longitude) || Number.isNaN(latitude)) {
      return;
    }
    let map = null;
    try {
      map = new AMapRef.Map("container", {
        zoom: 16,
        center: [longitude, latitude],
      });
      const marker = new AMapRef.Marker({
        position: [longitude, latitude],
      });
      map.add(marker);
    } catch (error) {
      // 高德 Key 未授权或平台不匹配时，SDK 可能抛运行时异常
      console.error("高德地图初始化失败", error);
      return;
    }

    const html = `
    <div class="cont">
        <div class="lr">
        <div class="tit ttt">${F_FullName}</div>
            <div class="ff">
            <br/>
                <span class="add">地址 </span>:
                <span>${F_Address}</span>
            </div>
        </div>
    </div>
`;
    const infoWindow = new AMapRef.InfoWindow({
      content: html,
      offset: new AMapRef.Pixel(0, -30),
      closeWhenClickMap: false,
    });
    infoWindow.open(map, [longitude, latitude]);
  },
  methods: {
    handleMapNav() {
      const link = this.getMapScheme(
        {
          longitude: this.$route.query.F_Longitude,
          latitude: this.$route.query.F_Latitude,
          name: this.$route.query.F_FullName,
        }
      );
      console.log("link",link);
      window.location.href = link;
    },
    getMapScheme(to) {
      const isMobile = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );

      if (isMobile) {
        return `https://m.amap.com/share/index/lnglat=${to.longitude},${to.latitude}&name=${to.name}&src=uriapi&innersrc=uriapi`;
      }
      return `https://ditu.amap.com/regeo?lng=${to.longitude}&lat=${to.latitude}&name=${to.name}&src=uriapi&innersrc=uriapi`;
    },
  },
};
</script>

<style lang="less" scoped>
body,
#mapRoot {
  //   min-width: 1280px;
  position: "relative";
  z-index: 99;
  width: 100vw;
  height: 100vh;
  @font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  user-select: none;
  box-sizing: border-box;
  #container {
    width:100%;
    height:100%;
  }
  #navIcon {
    position: absolute;
    right:20px;
    bottom: 20px;
    width:30px;
    height:30px;
    z-index: 21474836479;
    img {
        width: "25px";
        z-index: 21474836479;
    }
  }
}
</style>
